<template>
  <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal top" width="1100px">
    <Tabs>
        <TabPane :label="item.fileName" :name="String(index)" v-for="(item,index) in fileList" :key="index">
          <iframe :src="item.path" frameborder="0" v-if="item.path" class="iframe"></iframe>
        </TabPane>
    </Tabs>
  </Modal>
</template>

<script>
export default {
  data(){
    return{
      visible:false,
      title:'',
      fileList:[]
    }
  },
  methods:{
    open(item){
      this.visible = true
      this.fileList = item
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe{
  width: 100%;
  height: 100%;
}
/deep/ .ivu-tabs-content{
  height: 600px;
}
</style>